/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import logoSvg from '../../svg/agrolog_logo.svg';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function EmailVerifiedController($stateParams, $translate, toast, loginService, userService) {
    var vm = this;

    var token = '';
    var refreshToken = '';

    vm.activated = false;
    vm.logoSvg = logoSvg;
    vm.login = login;

    activateAndGetCredentials();

    function activateAndGetCredentials() {
        loginService.activateByEmailCode($stateParams.emailCode).then(function success(response) {
            token = response.data.token;
            refreshToken = response.data.refreshToken;
            vm.activated = true;
        }, function fail() {
        });
    }

    function login() {
        userService.setUserFromJwtToken(token, refreshToken, true);
    }
}